import {
  Container,
  Paper,
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import * as React from "react";
import format from "dateformat";

import "./../../assets/scss/App.scss";
import GlobalService from "../../services/global";
import Transaction from "./Transaction";
import FilterComponent from "./FilterComponent";

function Withdrawal() {
  // const [checked, setChecked] = React.useState([true, true, true, true]); //pending, processing, initiated, investing
  // let status = ["pending", "processing", "initiated", "investing"];

  // const [_checked, set_checked] = React.useState({
  //   initiated: true,
  //   investing: true,
  //   pending: true,
  //   processing: true,
  //   rejected: false,
  //   successful: false,
  // });
  // const _statuses = Object.keys(_checked);

  const [withTxs, setWithTxs] = React.useState<any[]>([]);
  const [filteredTxs, setFilteredTxs] = React.useState<any[]>([]);
  // const [filterTxs, setFilterTxs] = React.useState<any[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);
  const [refresh, setRefresh] = React.useState(true);

  // const getFilterTxUsingStatus = (data: []):Array<any> =>  {
  //   const hiddenStatuses = _statuses.filter((key) => !_checked[key]);

  //   return (data.filter((tx: any) => {
  //     if(!hiddenStatuses.includes(tx.status)) {
  //       return true
  //     } else {
  //       return false
  //     }
  //   }))
  // }

  React.useEffect(() => {
    const fetchTransactions = async () => {
      setIsLoading(true);
      const today = new Date();
      const thirtyDaysAgo = new Date(today);
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

      // get tx types, product, tx status, dates, from session storage
      let reqStr = `api/admin/txs?type=Withdraw&`;

      reqStr += `include=accountID&`; 

      if (sessionStorage.getItem("withdrawal-tx-status") != null) {
        if (sessionStorage.getItem("withdrawal-tx-status") != "")
          reqStr += `status=${sessionStorage.getItem("withdrawal-tx-status")}&`
      } else {
        reqStr += `status=pending&`
      }

      if (sessionStorage.getItem("withdrawal-tx-product-codes") != null) {
        if (sessionStorage.getItem("withdrawal-tx-product-codes") != "")
          reqStr += `product_codes=${sessionStorage.getItem("withdrawal-tx-product-codes")}&`
      }

      if (sessionStorage.getItem("withdrawal-tx-from") != null && sessionStorage.getItem("withdrawal-tx-to") != null) {
        if (sessionStorage.getItem("withdrawal-tx-from") != "" && sessionStorage.getItem("withdrawal-tx-to") != "")
          reqStr += `from=${new Date(sessionStorage.getItem("withdrawal-tx-from") as string).toISOString()}&to=${new Date(sessionStorage.getItem("withdrawal-tx-to") as string).toISOString()}`
      } else {
        reqStr += `from=${thirtyDaysAgo.toISOString()}&to=${today.toISOString()}`
      }
      console.log("======reqStrWithfrawal=======")
      console.log(reqStr)
  
      const data = await GlobalService.httpGet(reqStr);
      // console.log("trans: ", data);
      if (data) {
        //   data[0].status = "processing";
        setWithTxs(data);
        setFilteredTxs(data);
        // setFilterTxs(getFilterTxUsingStatus(data));
      }
      setIsLoading(false);
    };
    if(refresh) {
      fetchTransactions();
      setRefresh(false)
    }
  }, [refresh]);

  function getRows() {
    let rows: any[] = []
    filteredTxs.map((tx: any, index) => {
      rows.push(
        <Transaction key={index} tx={tx} index={index} setRefresh={setRefresh} tab="withdrawal" />
      )
    })
    return rows
  }

  function setTxs(txs: any[]) {
    setFilteredTxs(txs);
  }

  return (
    <Container sx={{ width: "100%", paddingTop: "30px" }}>
      <FilterComponent 
        // _checked={_checked}
        // filterTxs={filterTxs}
        // getFilterTxUsingStatus={getFilterTxUsingStatus}
        // setFilterTxs={setFilterTxs}
        // set_checked={set_checked}
        // txs={txs}
        tab={"withdrawal"}
        setTxs={setTxs}
        allTxs={withTxs}
        setIsLoading={setIsLoading}
        setAllTxs={setWithTxs}
      />
      <div style={{ margin: "20px 0" }}>
        <Typography variant="h6">
          Total Transactions: {filteredTxs.length}
        </Typography>
      </div>
      <div style={{ marginTop: "30px" }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell>UId</TableCell>
                <TableCell>Transaction Id</TableCell>
                <TableCell>Account ID</TableCell>
                <TableCell>Effective Date</TableCell>
                <TableCell>Product code</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Created On</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={9}>
                    <Skeleton />
                    <Skeleton animation="wave" />
                    {/* <Skeleton animation={false} /> */}
                  </TableCell>
                </TableRow>
              ) : !filteredTxs[0] ? (
                <TableRow>
                  <TableCell colSpan={9}>
                    <Typography>No Data</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                getRows()
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Container>
  );
}

export default Withdrawal;
